exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-body[data-v-6504d548]{width:100%;padding:10px}.icon-body .icon-list[data-v-6504d548]{height:200px;overflow-y:scroll}.icon-body .icon-list div[data-v-6504d548]{height:30px;line-height:30px;margin-bottom:-5px;cursor:pointer;width:33%;float:left}.icon-body .icon-list span[data-v-6504d548]{display:inline-block;vertical-align:-0.15em;fill:currentColor;overflow:hidden}", ""]);

// exports
